<script>
import api from '@/api/externalContact';
import Access from '@/utils/access';

import BaseInput from '@/components/BaseInput.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'ExternalContactListPopupWrappable',
  components: { BaseInput, EmptyList },
  data() {
    return {
      project: null,
      items: [],
      editable: null,
    };
  },
  computed: {
    access() { return new Access(this.project, this.$store.state.auth.user) },
    canEdit() { return this.access.canEditProject(); },
  },
  methods: {
    async init(params) {
      this.project = params.project ?? null;

      const response = await api.fetchList({ project: this.project.id }, true);
      this.items = response.items;
    },
    add() {
      this.editable = { name: '', project: this.project['@id']  };
      this.items.push(this.editable);
    },
    async save() {
      try {
        if (this.editable.id) {
          await api.update(this.editable.id, this.editable, true);
          this.editable = null;
          return;
        }

        const r = await api.create(this.editable, true);
        this.items = this.items.filter(r => r !== this.editable);
        this.items = [...this.items, r];
        this.editable = null;
      } catch (e) {
        const err = e.description === 'name: This name already exists within the project'
          ? 'Имя должно быть уникальным в рамках проекта'
          : 'Произошла ошибка';
        this.$alert(err);
      }
    },
    cancel() {
      if (!this.editable.id) {
        this.items = this.items.filter(r => r !== this.editable);
      }

      this.editable = null;
    },
    async remove(item) {
      if (!await this.$confirm('Удалить внешний контакт?')) return;

      try {
        await api.delete(item.id, true);
        this.items = this.items.filter(c => c.id !== item.id);
      } catch (e) {
        const err = e.description === 'Can not delete with agreements'
          ? 'Невозможно удалить этот внешний контакт, для него созданы соглашения'
          : 'Произошла ошибка';
        this.$alert(err);
      }
    },
    select(item) {
      this.$emit('finish', item ? item['@id'] : null);
    },
  },
}
</script>

<template lang="pug">
  .b-external-contact-list-popup-wrappable
    ._title Создать согласование
    EmptyList(v-if="items.length === 0" label="Добавьте внешнего пользователя")
    template(v-else)
      ._items(v-for="item in items")
        form._form(v-if="item === editable" @submit.prevent="save")
          BaseInput(v-model="editable.name")
          Btn._save(green :disabled="!editable.name" @click="save")
            Icon(name="check-green" colored pointer)
          Btn._cancel(grey @click="cancel")
            Icon(name="close-green" colored pointer)
        ._item(v-else)
          ._name {{ item.name }}
          template(v-if="canEdit")
            button._edit(@click="editable=item")
              Icon(name="edit" pointer colored)
            button._delete(@click="remove(item)")
              Icon(name="trash" pointer colored)
          Btn(@click="select(item)" sm green) Согласовать
    ._footer
      Btn(v-if="!editable" sm dark @click="add")
        Icon(name="plus" pointer)
        | Добавить
      //Btn(sm @click="select(null)") Согласовать без контакта
</template>

<style scoped lang="scss">

.external-contact-list-popup-wrappable {
  width: 650px;
  max-width: calc(100vw - 115px);

  &__title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 30px;
  }

  &__form {
    margin-bottom: 15px;
    display: grid;
    grid-template-columns: 1fr 38px 38px;
    gap: 20px;
    align-items: stretch;
  }

  &__save, &__cancel {
    padding: 0;
    aspect-ratio: 1;
    height: 38px;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  &__save svg {
    color: #fff;
  }

  &__cancel svg {
    color: #92A0B0;
  }

  &__list {
    margin-bottom: 20px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
  }

  &__name {
    margin-right: auto;
  }


  &__edit, &__delete {
    background: transparent;
    flex-shrink: 0;

    svg {
      color: #788CA1;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 30px;
    gap: 30px;
  }

  @media (max-width: 767px) {
    &__item {
      flex-wrap: wrap;
      margin-bottom: 30px;
    }

    &__name {
      width: 100%;
    }

    &__footer {
      flex-direction: column;
      gap: 20px;
    }
  }
}


</style>
